import { useUnit } from "effector-react";
import { useEffect, useCallback } from "react";
import { $ideasStore, fetchIdeaDetailRequested } from "../store";
import { $authStore } from "@/features/auth/store/auth";
import { $userBasicInfo } from "@/features/user/store";

export const useIdeaDetailViewModel = (id: string | undefined) => {
  const { selectedIdea, loading, error } = useUnit($ideasStore);
  const { user } = useUnit($authStore);
  const userBasicInfo = useUnit($userBasicInfo);

  useEffect(() => {
    if (id) {
      fetchIdeaDetailRequested(id);
    }
  }, [id]);

  const isIdeaInRequests = useCallback(() => {
    if (!selectedIdea?.actions || !Array.isArray(selectedIdea.actions)) {
      return false;
    }
    return selectedIdea.actions.some(
      (action) => action.action_type === "request"
    );
  }, [selectedIdea]);

  const isIdeaInInvitations = useCallback(() => {
    if (!selectedIdea?.actions || !Array.isArray(selectedIdea.actions)) {
      return false;
    }
    return selectedIdea.actions.some(
      (action) => action.action_type === "invitation"
    );
  }, [selectedIdea]);

  const refetchIdea = () => {
    if (id) {
      fetchIdeaDetailRequested(id);
    }
  };

  return {
    selectedIdea,
    loading,
    error,
    user,
    userBasicInfo,
    isIdeaInRequests,
    isIdeaInInvitations,
    refetchIdea,
  };
};
